// Custom zoom control with "home button" for Leaflet.js
// code credit: https://gis.stackexchange.com/a/127383/16381
(function (factory, window) {
     // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
     // for details on how to structure a leaflet plugin.

    // define an AMD module that relies on 'leaflet'
    if (typeof define === 'function' && define.amd) {
        define(['leaflet'], factory);

    // define a Common JS module that relies on 'leaflet'
    } else if (typeof exports === 'object') {
        if (typeof window !== 'undefined' && window.L) {
            module.exports = factory(L);
        } else {
            module.exports = factory(require('leaflet'));
        }
    }

    // attach your plugin to the global 'L' variable
    if (typeof window !== 'undefined' && window.L){
        window.L.Control.Locate = factory(L);
    }
} (function (L) {

  var ZoomHome = L.Control.extend({
      options: {
          lat: 37.670506,
          lng: -122.274399,
          position: 'topright',
          zoom: 9,
          zoomInText: '+',
          zoomInTitle: 'Zoom in',
          zoomOutText: '–',
          zoomOutTitle: 'Zoom out',
          zoomHomeText: '<span class="map-home" style="line-height:1.65;"></span>',
          zoomHomeTitle: 'Zoom home'
      },


      initialize: function (options) {
          // set default options if nothing is set (merge one step deep)
          for (var i in options) {
              if (typeof this.options[i] === 'object') {
                  L.extend(this.options[i], options[i]);
              } else {
                  this.options[i] = options[i];
              }
          }
      },

      onAdd: function (map) {
          var controlName = 'gin-control-zoom',
              container = L.DomUtil.create('div', controlName + ' leaflet-bar'),
              options = this.options;

          this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle,
          controlName + '-in', container, this._zoomIn);
          this._zoomHomeButton = this._createButton(options.zoomHomeText, options.zoomHomeTitle,
          controlName + '-home', container, this._zoomHome);
          this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
          controlName + '-out', container, this._zoomOut);

          this._updateDisabled();
          map.on('zoomend zoomlevelschange', this._updateDisabled, this);

          return container;
      },

      onRemove: function (map) {
          map.off('zoomend zoomlevelschange', this._updateDisabled, this);
      },

      _zoomIn: function (e) {
          this._map.zoomIn(e.shiftKey ? 3 : 1);
      },

      _zoomOut: function (e) {
          this._map.zoomOut(e.shiftKey ? 3 : 1);
      },

      _zoomHome: function (e) {
          this._map.setView([this.options.lat, this.options.lng], this.options.zoom);
      },

      _createButton: function (html, title, className, container, fn) {
          var link = L.DomUtil.create('a', className, container);
          link.innerHTML = html;
          link.href = '#';
          link.title = title;
          link.setAttribute('role', 'button');
          link.setAttribute('aria-label', title);

          L.DomEvent.on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
              .on(link, 'click', L.DomEvent.stop)
              .on(link, 'click', fn, this)
              .on(link, 'click', this._refocusOnMap, this);

          return link;
      },

      _updateDisabled: function () {
          var map = this._map,
              className = 'leaflet-disabled';

          L.DomUtil.removeClass(this._zoomInButton, className);
          L.DomUtil.removeClass(this._zoomOutButton, className);
          this._zoomInButton.removeAttribute('aria-disabled');
          this._zoomOutButton.removeAttribute('aria-disabled');

          if (map._zoom === map.getMinZoom()) {
              L.DomUtil.addClass(this._zoomOutButton, className);
              this._zoomOutButton.setAttribute('aria-disabled', 'true');
          }
          if (map._zoom === map.getMaxZoom()) {
              L.DomUtil.addClass(this._zoomInButton, className);
              this._zoomInButton.setAttribute('aria-disabled', 'true');
          }
      }
  });

  L.control.zoomHome = function(options) {
    return new L.Control.ZoomHome(options);
  }

  return ZoomHome;
}, window));



// WEBPACK FOOTER //
// ./lib/L.Control.ZoomHome.js